// extracted by mini-css-extract-plugin
export default {"input":"styles_input__6n6u2","label":"styles_label__1yGDA","errorMessage":"styles_errorMessage__zjAZD"};